import { Label } from "../ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

export const AdminViewDialog = ({ open, onOpenChange, item }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Details</DialogTitle>
        </DialogHeader>
        {item && (
          <div className="space-y-4">
            {Object.entries(item).map(([key, value]) => (
              key !== "id" && (
                <div key={key}>
                  <Label className="text-xs uppercase tracking-wider text-gray-500">
                    {key.replace(/_/g, " ")}
                  </Label>
                  <p className="mt-1 text-gray-900">
                    {key === "created_at" ? formatDate(value) : value || "N/A"}
                  </p>
                </div>
              )
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
